var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLockImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.72 8.20236V6.64823C15.72 2.98415 12.7064 0 9 0C5.29364 0 2.27727 2.98415 2.27727 6.64823V8.20236C1.01727 8.21855 0 9.23575 0 10.4877V21.7147C0 22.9774 1.03364 24 2.31 24H15.6873C16.9636 24 17.9973 22.9774 17.9973 21.7147V10.4877C17.9973 9.23575 16.98 8.22125 15.72 8.20236ZM9 2.15852C11.5036 2.15852 13.5382 4.17403 13.5382 6.64823V8.19966H4.45909V6.64823C4.45909 4.17133 6.49636 2.15852 8.99727 2.15852H9ZM10.2218 17.3976V18.4634C10.2218 19.1299 9.67364 19.6722 9 19.6722C8.32636 19.6722 7.77818 19.1299 7.77818 18.4634V17.3976C7.04727 16.9794 6.55636 16.1997 6.55636 15.3066C6.55636 13.971 7.65 12.889 9 12.889C10.35 12.889 11.4436 13.971 11.4436 15.3066C11.4436 16.1997 10.9527 16.9794 10.2218 17.3976Z",
    fill: "#747F94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLockImage);
export default __webpack_public_path__ + "static/media/footer-lock-image.3cc5e11d1cacd1642ac9d0aa0da467cf.svg";
export { ForwardRef as ReactComponent };